import {getData, LOGIN} from "../storage";
import {isEmpty} from "../utility";

const getUserList = (props, query = '', type = 'all', page = 1) => {
    getData(LOGIN)
        .then((data) => {
            if (!isEmpty(data)) {
                props.getUserList(
                    data.token,
                    data.api_token,
                    query,
                    type,
                    page
                );
            }
        })
}

const blockUser = (props,id,user_type)=>{
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.blockUser(data.token, data.api_token, id,user_type);
        }
    });
}

const postContentInChatAPI = (props,postArray)=>{
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.postContentInChat(data.token, data.api_token,postArray);
        }
    });
}

const getChatPostAPI = (props, idsArray) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data)) {
            props.getChatPost(data.token, data.api_token, idsArray);
        }
    });
}

const purchaseChatContentAPI = (props, chat_post_id, chat_post_amount) => {

    let requestData = {};

    if (props.moneyblox.hasOwnProperty("user_details") && props.moneyblox.user_details !== null) {

        requestData = {
            "width": 500,
            "height": null,
            "uuid": chat_post_id,
            "amount": chat_post_amount,
            moneyblox: {
                token: props.moneyblox.user_details.token,
                api_token: props.moneyblox.user_details.api_token,
            },
            device: {
                platform: props.device.platform,
                name: props.device.name,
                version: props.device.version,
                ip: props.device.ip,
                id: props.device.id,
                app_version: props.device.app_version,
                device_token: props.device.device_token,
            },
        };

        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    props.purchaseChatContent(
                        data.token,
                        data.api_token,
                        requestData
                    );
                }
            })

    }
}

export default {
    getUserList,
    blockUser,
    postContentInChatAPI,
    getChatPostAPI,
    purchaseChatContentAPI
}